(function() {
  function updateCartDrawer(parsedState) {
    // Only update the cart drawer section, do NOT touch the header icon
    if (parsedState.sections && parsedState.sections['cart-drawer']) {
      var existingDrawer = document.querySelector('cart-drawer');
      if (existingDrawer) {
        existingDrawer.outerHTML = parsedState.sections['cart-drawer'];
      }
    }

    // Open the (possibly newly replaced) drawer
    var newDrawer = document.querySelector('cart-drawer');
    if (newDrawer) {
      if (typeof newDrawer.open === 'function') {
        newDrawer.open();
      } else {
        newDrawer.setAttribute('open', 'open');
      }
    }
  }

  function updateCartCount(qtyToAdd) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    var bubble = icon.querySelector('.cart-count-bubble');
    var countSpan;

    // If there is no bubble yet (cart was empty), create it
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';

      countSpan = document.createElement('span');
      countSpan.setAttribute('aria-hidden', 'true');
      countSpan.textContent = '0';

      var srSpan = document.createElement('span');
      srSpan.className = 'visually-hidden';
      srSpan.textContent = '';

      bubble.appendChild(countSpan);
      bubble.appendChild(srSpan);
      icon.appendChild(bubble);
    } else {
      countSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (!countSpan) {
        countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(countSpan, bubble.firstChild);
      }
    }

    var current = parseInt((countSpan.textContent || '0').replace(/[^\d]/g, ''), 10);
    if (isNaN(current)) current = 0;

    var newCount = current + qtyToAdd;
    countSpan.textContent = newCount;

    var srSpan2 = bubble.querySelector('.visually-hidden');
    if (srSpan2) {
      // No translation here, but at least keep number in sync
      srSpan2.textContent = newCount;
    }
  }

  //Smarter version — waits for drawer to finish rendering, not a fixed delay
    function triggerThemeCartRefresh() {
    let attempts = 0;
    const maxAttempts = 20; // 20 * 30ms = max ~600ms

    const interval = setInterval(function() {
        attempts++;

        var drawer = document.querySelector('cart-drawer');
        if (!drawer) {
        if (attempts >= maxAttempts) clearInterval(interval);
        return;
        }

        // Try detecting ANY quantity input the theme might use
        var qtyInput =
        drawer.querySelector('quantity-input input.quantity__input') ||
        drawer.querySelector('.cart-item__quantity input') ||
        drawer.querySelector('input[name^="updates"]');

        if (qtyInput) {
        clearInterval(interval);

        // Fire change event to trigger theme’s related products refresh
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (attempts >= maxAttempts) {
        clearInterval(interval);
        }
    }, 30);
    }

  function handleUpsellSubmit(form) {
    if (!form || form.dataset.kwUpsellLoading === 'true') return;

    form.dataset.kwUpsellLoading = 'true';

    var formData = new FormData(form);
    var qty = parseInt(formData.get('quantity') || '1', 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    // Only ask Shopify to render the cart drawer section
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function(parsedState) {
        updateCartDrawer(parsedState);
        updateCartCount(qty);

        // Let the rest of the theme know the cart changed (if anything listens to these)
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { source: 'upsell' } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:open', { detail: { source: 'upsell' } })
        );

        // 🔧 Now explicitly trigger the same path that makes related products appear on quantity change
        triggerThemeCartRefresh();
      })
      .catch(function(error) {
        console.error('Upsell add-to-cart error:', error);
        // We *don't* redirect or click the cart icon here – just fail silently.
      })
      .finally(function() {
        form.dataset.kwUpsellLoading = 'false';
      });
  }

  // 1) Intercept submit on upsell forms only (CAPTURE PHASE + hard stop)
  document.addEventListener(
    'submit',
    function(event) {
      var form = event.target.closest('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleUpsellSubmit(form);
    },
    true // capture: true → runs before theme/app submit handlers
  );

  // 2) Intercept direct clicks on the upsell button (some themes hook button clicks)
  document.addEventListener(
    'click',
    function(event) {
      var button = event.target.closest('.kw-upsell__button');
      if (!button) return;

      var form = button.closest('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleUpsellSubmit(form);
    },
    true
  );

  // 3) Make the entire upsell banner clickable (delegated)
  document.addEventListener(
    'click',
    function(event) {
      var banner = event.target.closest('.kw-upsell__inner[data-kw-upsell-click]');
      if (!banner) return;

      var form = banner.querySelector('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      // If user clicked directly on the upsell button, the button handler above will take over
      var clickOnButton = event.target.closest('.kw-upsell__button');
      if (clickOnButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleUpsellSubmit(form);
    },
    true
  );
})();
